// extracted by mini-css-extract-plugin
export var cardHeader = "_s2-0";
export var reorderHandle = "_s2-3";
export var titleArea = "_s2-1";
export var titleAreaWithHandle = "_s2-2";